"use client"
import { InviteMemberForm } from "@/components/invite-member-form"
import { IconButton } from "@/components/ui/IconButton"
import { Modal } from "@/components/ui/Modal"
import { Tooltip } from "@/components/ui/Tooltip"
import type { TeamInvitation } from "@prisma/client"
import { UserPlus } from "lucide-react"
import { useRouter, useSearchParams } from "next/navigation"

export function InviteColleaguesNavIcon({ invites }: { invites: Pick<TeamInvitation, "id" | "email" | "teamId">[] }) {
  const searchParams = useSearchParams()
  const showInviteColleages = !!searchParams?.has("invite-colleages")
  const router = useRouter()
  return (
    <>
      <Tooltip label="Invite colleagues for free">
        <IconButton
          className="tour-home-invite hidden size-9 lg:block"
          onClick={() => router.push(`?invite-colleages=true`)}
          icon={<UserPlus size={16} />}
          aria-label="Invite colleagues"
          variant="outline"
        />
      </Tooltip>

      <Modal
        size="xl"
        isOpen={!!showInviteColleages}
        onClose={() => router.push("?")}
        title={
          invites.length > 0 ? "Invite more colleagues (it's included in your plan!)" : "You currently have no pending invites"
        }
        description={invites.length === 0 && "Start inviting more people below"}
      >
        <InviteMemberForm onClose={() => router.push("?")} invites={invites} />
      </Modal>
    </>
  )
}
